module.exports = __webpack_public_path__ + "static/media/Univers-reg.46e61113.woff2";